/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { IconsError } from "../../icons/IconsError";
import "./style.css";

export const ComponenteText = ({
  iconDer,
  iconIz,
  default1,
  active,
  color,
  focus,
  error,
  msjIz,
  msjDer,
  labelDer,
  disabled,
  msjIz2,
  className,
  text = "Label",
  divClassName,
  text1 = "Placeholder",
  icon = <IconsError className="icon-iz" />,
  mensajeIzqClassName,
  text2 = "Mensaje de apoyo al campo",
}) => {
  return (
    <div className={`componente-text ${className}`}>
      <div className="labels" style={{ marginBottom: 1 }}>
        <div className="label-izq" style={{ marginBottom: 2 }}>
          {text}
        </div>
      </div>

      <div className="campo">
        <div className="content">
          <div
            className={`placeholder ${divClassName}`}
            style={{ color: color }}
          >
            {text1}
          </div>

          {msjIz2 && <>{icon}</>}
        </div>
      </div>

      {msjIz2 && (
        <div className="mensajes">
          <div className="msj-izq">
            <p
              className={`mensaje-izq ${mensajeIzqClassName}`}
              style={{ color: color }}
            >
              {text2}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

ComponenteText.propTypes = {
  iconDer: PropTypes.bool,
  iconIz: PropTypes.bool,
  default1: PropTypes.bool,
  active: PropTypes.bool,
  focus: PropTypes.bool,
  error: PropTypes.bool,
  msjIz: PropTypes.bool,
  msjDer: PropTypes.bool,
  labelDer: PropTypes.bool,
  disabled: PropTypes.bool,
  msjIz2: PropTypes.bool,
  text: PropTypes.string,
  text1: PropTypes.string,
  text2: PropTypes.string,
};
